import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ApplyCreditMemoMutationVariables = Types.Exact<{
  input: Types.ApplyCreditMemoInput;
}>;


export type ApplyCreditMemoMutation = { __typename?: 'Mutation', applyCreditMemo: { __typename?: 'ApplyCustomerCreditPayload', invoice?: { __typename?: 'InvoiceStateData', invoiceId: string, balance: number, status: Types.InvoiceStatus, amountCreditApplied: number } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type IssueCreditMemoMutationVariables = Types.Exact<{
  input: Types.IssueCreditMemoInput;
}>;


export type IssueCreditMemoMutation = { __typename?: 'Mutation', issueCreditMemo: { __typename?: 'CreditMemoPayload', creditMemo?: { __typename?: 'CreditMemoStateData', creditMemoNumber: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const ApplyCreditMemoDocument = new TypedDocumentString(`
    mutation ApplyCreditMemo($input: ApplyCreditMemoInput!) {
  applyCreditMemo(input: $input) {
    invoice {
      ...CreditAppliedInvoiceState
    }
    errors {
      code
      message
    }
  }
}
    fragment CreditAppliedInvoiceState on InvoiceStateData {
  invoiceId
  balance
  status
  amountCreditApplied
}`);
export const IssueCreditMemoDocument = new TypedDocumentString(`
    mutation IssueCreditMemo($input: IssueCreditMemoInput!) {
  issueCreditMemo(input: $input) {
    creditMemo {
      ...IssuedCreditMemo
    }
    errors {
      code
      message
    }
  }
}
    fragment IssuedCreditMemo on CreditMemoStateData {
  creditMemoNumber
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    ApplyCreditMemo: build.mutation<ApplyCreditMemoMutation, ApplyCreditMemoMutationVariables>({
      query: (variables) => ({ document: ApplyCreditMemoDocument, variables })
    }),
    IssueCreditMemo: build.mutation<IssueCreditMemoMutation, IssueCreditMemoMutationVariables>({
      query: (variables) => ({ document: IssueCreditMemoDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useApplyCreditMemoMutation, useIssueCreditMemoMutation } = injectedRtkApi;
